import { createRouter, createWebHistory } from "vue-router";
import { isAuthenticated } from "@/utils/auth";

const routes = [
  {
    path: "/",
    name: "login",
    component: () => import("../views/LoginView.vue"),
    beforeEnter: (to, from, next) => {
      if (isAuthenticated()) {
        const userRole = localStorage.getItem("userRole");
        const token = localStorage.getItem("token"); // ✅ ده اللي بيحتوي على UUID

        if (userRole === "teacher" && token) {
          next({ name: "teacherprofile", params: { id: token } });
        } else if (userRole === "Admin") {
          next({ name: "admin" });
        } else {
          next({ name: "ourteachers" });
        }
      } else {
        next();
      }
    },
  },

  {
    path: "/signup",
    name: "signup",
    component: () => import("../views/SignupView.vue"),
  },
  {
    path: "/ourteachers",
    name: "ourteachers",
    component: () => import("@/views/OurTeachersView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/teacherwall/:id",
    name: "teacherwall",
    component: () => import("@/views/TeacherWallView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/singlecourse/:id",
    name: "singlecourse",
    component: () => import("@/views/SingleCourseView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/editsinglecourse/:id",
    name: "editsinglecourse",
    component: () => import("@/views/EditSingleCourseView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/teacherprofile/:id",
    name: "teacherprofile",
    component: () => import("@/views/ProfileTeacherWallView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/admin",
    name: "admin",
    component: () => import("@/views/Admin.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/forgetpassword",
    name: "forgetpassword",
    component: () => import("@/views/ForgetPasswordView.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// ✅ simple route guard (no cookies)
router.beforeEach((to, from, next) => {
  if (to.matched.some((r) => r.meta.requiresAuth) && !isAuthenticated()) {
    next({ name: "login" });
  } else {
    next();
  }
});

export default router;
